import React from 'react';
import { Link } from '@pushpay/link';
import Tooltip from '@pushpay/tooltip';
import { useScrollIntoViewOnMount } from '@pushpay/utils';
import { useIsActive } from './helpers';
import { NavigationItem } from './navigation-item';
import { useNavigationStyles } from './navigation-styles';
import { useNavigation } from './use-navigation';
export function NavigationLinkItem({
  icon: Icon,
  indicatorIcon: IndicatorIcon,
  indicatorIconTooltip,
  label,
  classes: classesProp,
  displayStyle,
  scrolling,
  end = true,
  ...rest
}) {
  var _rest$to;

  const classes = useNavigationStyles(classesProp);
  const {
    navContainerRef
  } = useNavigation();
  const activeItemScrollRef = useScrollIntoViewOnMount({
    container: navContainerRef,
    behavior: 'auto'
  });
  const isActive = useIsActive((_rest$to = rest.to) !== null && _rest$to !== void 0 ? _rest$to : rest.href);
  return /*#__PURE__*/React.createElement(Tooltip, {
    className: classes.tooltip,
    disabled: displayStyle === 'expanded' || scrolling,
    placement: "right",
    content: label,
    panelSpace: "XXSMALL"
  }, /*#__PURE__*/React.createElement(Link, Object.assign({
    end: end,
    ref: isActive ? activeItemScrollRef : undefined,
    tabIndex: isActive ? 0 : -1,
    displayStyle: "unstyled",
    classes: {
      root: classes.item,
      active: classes.itemActive
    }
  }, rest), /*#__PURE__*/React.createElement(NavigationItem, {
    label: label,
    icon: Icon,
    displayStyle: displayStyle,
    indicatorIcon: IndicatorIcon,
    indicatorIconTooltip: indicatorIconTooltip
  })));
}